export const tag = {
  root: {
    fontSize: "{typography.caption.text.semibold.font.size}",
    fontWeight: "{typography.caption.text.semibold.font.weight}",
    padding: "{padding.4} {padding.8}",
    gap: "{gap.4}",
    borderRadius: "{border.radius.6}",
    roundedBorderRadius: "{border.radius.12}",
  },
  icon: {
    size: "10px",
  },

  colorScheme: {
    light: {
      primary: {
        background: "{primary.default}",
        color: "{text.button-primary}",
      },
      secondary: {
        background: "{surface.bg-grey-contrast}",
        color: "{text.body}",
      },
      success: {
        background: "{success.support}",
        color: "{success.default}",
      },
      info: {
        background: "{info.support}",
        color: "{info.default}",
      },
      warn: {
        background: "{warning.support}",
        color: "{warning.default}",
      },
      danger: {
        background: "{danger.support}",
        color: "{danger.default}",
      },
      // contrast: {
      //   background: "{surface.950}",
      //   color: "{surface.0}",
      // },
    },
    dark: {
      primary: {
        background: "{primary.support}",
        color: "{text.body}",
      },
      secondary: {
        background: "{surface.bg-grey-contrast}",
        color: "{text.body}",
      },
      success: {
        background: "{success.support}",
        color: "{success.default}",
      },
      info: {
        background: "{info.support}",
        color: "{info.default}",
      },
      warn: {
        background: "{warning.support}",
        color: "{warning.default}",
      },
      danger: {
        background: "{danger.support}",
        color: "{danger.default}",
      },
      // contrast: {
      //   background: "{surface.950}",
      //   color: "{surface.0}",
      // }
    },
  },
  extend: {
    ui: {
      root: {
        fontLeading: "100%",
      },
      label: {
        minWidth: "calc({tag.font.size} * 2)",
        minHeight: "{tag.font.size}",
        /* opinionated as fuck tho */
        whiteSpace: "nowrap",
        /* check the tag displaying amount of tasks for candidate */
      },
      rounded: {
        padding: "{padding.6} {padding.12}",
        fontLeading: "{typography.caption.text.semibold.font.leading}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-tag {
      line-height: ${dt("tag.ui.font.leading")};
    }

    .p-tag-rounded {
      padding: ${dt("tag.ui.rounded.padding")};
      line-height: ${dt("tag.ui.rounded.font.leading")};
    }

    .p-tag-label {
      white-space: ${dt("tag.ui.label.white.space")};
      text-align: center;
      min-width: ${dt("tag.ui.label.min.width")};
      min-height: ${dt("tag.ui.label.min.height")};
    }

    .p-tag-label:empty {
      display: none;
    }

    .p-tag a {
      color: inherit;
    }

    .p-tag-icon-last .p-tag-icon {
      order: 2;
    }

    /* Process model tree node tag colors */
    .p-tag.pm-tag-indigo {
      background-color: #e8eaf6;
      color: #3949ab;
    }
    .p-tag.pm-tag-green {
      background-color: #e8f5e9;
      color: #2e7d32;
    }
    .p-tag.pm-tag-purple {
      background-color: #f3e5f5;
      color: #7b1fa2;
    }
    .p-tag.pm-tag-gray {
      background-color: #f0ece4;
      color: #8c8378;
    }

    /* Process model tree node tag font weights */
    .p-tag.pm-font-bold .p-tag-label { font-weight: 700; }
    .p-tag.pm-font-semibold .p-tag-label { font-weight: 600; }
    .p-tag.pm-font-medium .p-tag-label { font-weight: 500; }
    .p-tag.pm-font-normal .p-tag-label { font-weight: 400; }
  `,
};
